import React from "react";

/**
 * Miniature site preview rendered from the merged token set (defaults +
 * overrides + calculated colours), mirroring the template's regions.
 */
export function BrandingPreview({ merged }: { merged: Record<string, string> }) {
  const v = (k: string) => merged[k];
  return (
    <div
      className="overflow-hidden rounded-lg border"
      style={{ background: v("bg"), color: v("text"), fontFamily: v("font-body") }}
    >
      <div
        className="flex items-center justify-between px-4 py-2 text-sm"
        style={{ background: v("header-bg"), color: v("header-text") }}
      >
        <span style={{ fontFamily: v("font-heading"), fontWeight: v("font-weight-bold") }}>
          Acme Co
        </span>
        <span className="text-xs opacity-80">Home · About · Contact</span>
      </div>
      <div
        className="px-4 py-6 text-center"
        style={{ background: v("hero-bg"), color: v("hero-text") }}
      >
        <div
          style={{
            fontFamily: v("font-heading"),
            fontSize: v("h3"),
            lineHeight: v("leading-tight"),
            fontWeight: v("heading-weight"),
            fontStyle: v("heading-style") as React.CSSProperties["fontStyle"],
            textTransform: v("heading-case") as React.CSSProperties["textTransform"],
            letterSpacing: v("heading-tracking"),
          }}
        >
          Welcome
        </div>
        <div className="text-xs opacity-85">A preview of your branding</div>
      </div>
      <div className="space-y-3 px-4 py-4">
        <div
          style={{
            fontFamily: v("font-heading"),
            fontSize: v("h5"),
            lineHeight: v("leading-tight"),
            fontWeight: v("heading-weight"),
            fontStyle: v("heading-style") as React.CSSProperties["fontStyle"],
            textTransform: v("heading-case") as React.CSSProperties["textTransform"],
            letterSpacing: v("heading-tracking"),
          }}
        >
          A section heading
        </div>
        <p className="text-xs" style={{ color: v("text-muted") }}>
          Body copy uses the calculated text colour. Heading sizes follow your
          typography scale; this card and button reflect your brand colour, radius
          and shadow choices.
        </p>
        <button
          type="button"
          className="px-4 py-2 text-xs font-semibold text-white"
          style={{ background: v("accent"), borderRadius: v("radius"), boxShadow: v("shadow-sm") }}
        >
          Call to action
        </button>
      </div>
      <div
        className="px-4 py-2 text-[10px]"
        style={{ background: v("footer-bg"), color: v("footer-text") }}
      >
        © Acme Co
      </div>
    </div>
  );
}
